{
  "customer-register-dialog": {
    "buttons": {
      "cancel": "Abbrechen",
      "next": "Weiter"
    },
    "text": {
      "book_as_guest": "Als Gast buchen",
      "login": "melden Sie sich an",
      "or": " oder ",
      "register": "registrieren Sie sich",
      "to_manage": "Um alle Ihre Buchungen und Lieblingssalons zu verwalten, bitte "
    }
  }
}
